import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'
import './rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationProvider', ValidationProvider)
